/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const ExportIcon: React.FC = (): JSX.Element => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.6665 3.14819H3.99984C3.26346 3.14819 2.6665 3.74515 2.6665 4.48153V12.3342C2.6665 13.0706 3.26346 13.6675 3.99984 13.6675H11.9998C12.7362 13.6675 13.3332 13.0706 13.3332 12.3342V9.72276"
      stroke="#878787"
      stroke-linecap="round"
    />
    <path
      d="M9.33325 3.14819L13.3333 3.14819L13.3333 7.14819"
      stroke="#878787"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M13.3333 3.14819L7.33325 9.14819" stroke="#878787" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
